import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import {
  AgrBlockSpinnerModule,
  AgrNotificationEmptyModule,
  AgrPageDetailModule,
  AgrPrimaryActionModule,
  AgrPageToolbarModule,
} from '@next/core-lib/components';
import { TableV2Module } from '@next/core-lib/table-v2';

import { EmployeeDetailComponent } from './components/employee-detail/employee-detail.component';
import { EmployeeItemComponent } from './components/employee-item/employee-item.component';
import { EmployeeNavigationComponent } from './components/employee-navigation/employee-navigation.component';
import { EmployeeOverviewComponent } from './components/employee-overview/employee-overview.component';
import { EmployeeRelationCreateComponent } from './components/employee-relation-create/employee-relation-create.component';
import { EmployeeRelationsComponent } from './components/employee-relations/employee-relations.component';
import { EmployeeComponent } from './employee.component';
import { EmployeeService } from './services/employee.service';
import { CustomerService } from '../customer/services/customer.service';
import { AgrSearchFieldModule } from '../shared/components/search-field/search-field.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    EmployeeOverviewComponent,
    EmployeeItemComponent,
    EmployeeNavigationComponent,
    EmployeeDetailComponent,
    EmployeeRelationsComponent,
    EmployeeRelationCreateComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    AgrSearchFieldModule,
    AgrPageDetailModule,
    AgrPrimaryActionModule,
    EmployeeComponent,
    AgrPageToolbarModule,
    AgrNotificationEmptyModule,
    AgrBlockSpinnerModule,
    MatListModule,
    MatDividerModule,
    MatIconModule,
    MatTabsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    MatTableModule,
    TableV2Module,
  ],
  providers: [EmployeeService, CustomerService],
})
export class EmployeeModule {}
